import { QRCodeSVG } from 'qrcode.react';

import { MEDIA } from '../../constants/media';

export const GET_APP_PATH = '/get-app';

export function getAppDownloadQRValue() {
  return typeof window !== 'undefined'
    ? window.location.origin + GET_APP_PATH
    : GET_APP_PATH;
}

type AppDownloadQRProps = {
  size?: number;
  className?: string;
};

export default function AppDownloadQR({
  size = 180,
  className = '',
}: AppDownloadQRProps) {
  const logoSize = Math.round(size * (48 / 180));

  return (
    <QRCodeSVG
      className={className}
      value={getAppDownloadQRValue()}
      size={size}
      level="H"
      fgColor="#000000"
      bgColor="#ffffff"
      imageSettings={{
        src: MEDIA.logo,
        height: logoSize,
        width: logoSize,
        excavate: true,
      }}
    />
  );
}
